// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { jsx as _jsx } from "react/jsx-runtime";
import { RenderCategoryLayoutElement } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/RenderCategoryLayoutElement";
import React from "react";
export var SDUICategoryPageLayoutElementRenderer = function(param) {
    var component = param.component, loggingData = param.loggingData;
    var layoutElement = component.layout_element;
    if (!layoutElement) {
        return null;
    }
    var _loggingData_request_id;
    return /*#__PURE__*/ _jsx(RenderCategoryLayoutElement, {
        layoutElement: layoutElement,
        requestId: (_loggingData_request_id = loggingData.request_id) !== null && _loggingData_request_id !== void 0 ? _loggingData_request_id : "",
        omitCategoryPageStyling: true
    });
};
